// DO NOT EDIT. These types are generated.
export type IconNames =
  | 'analytics'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'blocked'
  | 'calendar'
  | 'check-circle'
  | 'check'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'chevrons-down'
  | 'chevrons-up'
  | 'close-circle'
  | 'close'
  | 'color-picker'
  | 'comment'
  | 'content'
  | 'copy'
  | 'credit-card'
  | 'delete'
  | 'device-desktop'
  | 'device-mobile'
  | 'download'
  | 'edit'
  | 'email'
  | 'error'
  | 'external-link'
  | 'favorite'
  | 'file-settings'
  | 'file'
  | 'filter'
  | 'frown'
  | 'gift'
  | 'grid-view'
  | 'grip-neutral'
  | 'grip-vertical'
  | 'hide'
  | 'history'
  | 'home'
  | 'image'
  | 'infinity'
  | 'info'
  | 'language'
  | 'layers'
  | 'layout'
  | 'light-mode'
  | 'link'
  | 'list-todo'
  | 'list-view'
  | 'location'
  | 'lock'
  | 'map'
  | 'meh'
  | 'menu'
  | 'message'
  | 'minus'
  | 'more-horizontal'
  | 'more-vertical'
  | 'move'
  | 'narvar-logo'
  | 'notifications'
  | 'package'
  | 'palette'
  | 'panel-left-2'
  | 'panel-left'
  | 'panel-right-2'
  | 'panel-right'
  | 'pending'
  | 'permissions'
  | 'placeholder-status'
  | 'plug'
  | 'plus-circle'
  | 'plus'
  | 'printer'
  | 'qr'
  | 'question'
  | 'redo'
  | 'refresh'
  | 'refund'
  | 'save'
  | 'search'
  | 'security-check'
  | 'security-warning'
  | 'send'
  | 'settings'
  | 'share'
  | 'show'
  | 'sign-in'
  | 'sign-out'
  | 'sliders'
  | 'smile'
  | 'sort-ascending'
  | 'sort-descending'
  | 'sort'
  | 'soundwave'
  | 'split'
  | 'store'
  | 'table-view'
  | 'tag'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'track-package'
  | 'truck'
  | 'undo'
  | 'unlock'
  | 'upload'
  | 'user'
  | 'users'
  | 'voice-input'
  | 'warning'
  | 'workflow'
  | 'zap';
export const iconNameOptions: IconNames[] = [
  'analytics',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'blocked',
  'calendar',
  'check-circle',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevrons-down',
  'chevrons-up',
  'close-circle',
  'close',
  'color-picker',
  'comment',
  'content',
  'copy',
  'credit-card',
  'delete',
  'device-desktop',
  'device-mobile',
  'download',
  'edit',
  'email',
  'error',
  'external-link',
  'favorite',
  'file-settings',
  'file',
  'filter',
  'frown',
  'gift',
  'grid-view',
  'grip-neutral',
  'grip-vertical',
  'hide',
  'history',
  'home',
  'image',
  'infinity',
  'info',
  'language',
  'layers',
  'layout',
  'light-mode',
  'link',
  'list-todo',
  'list-view',
  'location',
  'lock',
  'map',
  'meh',
  'menu',
  'message',
  'minus',
  'more-horizontal',
  'more-vertical',
  'move',
  'narvar-logo',
  'notifications',
  'package',
  'palette',
  'panel-left-2',
  'panel-left',
  'panel-right-2',
  'panel-right',
  'pending',
  'permissions',
  'placeholder-status',
  'plug',
  'plus-circle',
  'plus',
  'printer',
  'qr',
  'question',
  'redo',
  'refresh',
  'refund',
  'save',
  'search',
  'security-check',
  'security-warning',
  'send',
  'settings',
  'share',
  'show',
  'sign-in',
  'sign-out',
  'sliders',
  'smile',
  'sort-ascending',
  'sort-descending',
  'sort',
  'soundwave',
  'split',
  'store',
  'table-view',
  'tag',
  'thumbs-down',
  'thumbs-up',
  'track-package',
  'truck',
  'undo',
  'unlock',
  'upload',
  'user',
  'users',
  'voice-input',
  'warning',
  'workflow',
  'zap',
];
